<template>
  <v-dialog v-model="internalDialog" max-width="800px">
    <v-card>
      <!-- Header -->
      <v-card-title>Detail Stok</v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <!-- Tanggal & Loading -->
        <div class="mb-4 font-weight-bold">Tanggal: {{ selectedDate }}</div>
        <div v-if="loading" class="text-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>

        <!-- Table -->
        <div v-else>
          <div v-if="detailProducts.length === 0" class="text-center text--secondary">
            Tidak ada data detail stok untuk tanggal ini.
          </div>
          <div v-else class="scrollable-table-container">
            <table class="fixed-table">
              <thead>
                <tr>
                  <th>Product Code</th>
                  <th>Product Name</th>
                  <th class="text-right">Qty</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in detailProducts" :key="idx">
                  <td class="text-center">{{ item.product_code }}</td>
                  <td class="text-center">{{ item.product_name }}</td>
                  <td class="text-right">{{ item.quantity_ordered }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2" class="text-right font-weight-bold">Total</td>
                  <td class="text-right font-weight-bold">{{ totalQty }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>

      <!-- Footer -->
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Tutup</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AdditionalDetailDialog',
  props: {
    dialog: Boolean,
    outletcode: String,
    selectedDate: String,
  },
  data() {
    return {
      internalDialog: this.dialog,
      loading: false,
      detailProducts: [],
    };
  },
  watch: {
    dialog(val) {
      this.internalDialog = val;
      if (val && this.selectedDate) {
        this.loadDetail();
      }
    },
    internalDialog(val) {
      this.$emit('update:dialog', val);
    }
  },
  computed: {
    totalQty() {
      return this.detailProducts
        .reduce((sum, item) => sum + Number(item.quantity_ordered || 0), 0)
    }
  },
  methods: {
    async loadDetail() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('po/getDetailPOAdditional', {
          outletcode: this.outletcode,
          date: this.selectedDate,
        });

        if (response.data.status === 'success') {
          this.detailProducts = response.data.data.products;
        } else {
          this.$store.commit('setSnackbar', {
            saveError: true,
            errorMessage: response.data.message
          });
        }
      } catch (err) {
        this.$store.commit('setSnackbar', {
          saveError: true,
          errorMessage: 'Gagal memuat data detail.'
        });
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.internalDialog = false;
    },
  }
};
</script>

<style scoped>
.product-name {
  font-size: 12px;
}
.scrollable-table-container {
  max-height: 400px; /* sesuaikan tinggi area scroll */
  overflow-y: auto;
}

.fixed-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.fixed-table th,
.fixed-table td {
  padding: 8px;
  border-bottom: 1px solid #e0e0e0;
}

/* Sticky header */
.fixed-table thead th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
  border-bottom: 2px solid #ccc;
}

/* Sticky footer */
.fixed-table tfoot td {
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 2;
  border-top: 2px solid #ccc;
}
</style>